import { create } from 'zustand';
import { authService } from '../services/auth-service';
import type { AuthUser, LoginRequest } from '../types/auth';

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  error: string | null;
  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => void;
  initialize: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,

  initialize: () => {
    if (authService.isAuthenticated()) {
      set({ user: authService.getCurrentUser() });
    }
  },

  login: async (credentials: LoginRequest) => {
    set({ isLoading: true, error: null });
    try {
      await authService.login(credentials);
      const user = authService.getCurrentUser();
      set({ user, isLoading: false });
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : 'Username or password is incorrect';
      set({ error: message, isLoading: false });
      throw err;
    }
  },

  logout: () => {
    authService.logout();
    set({ user: null });
  },
}));
